import { IPayout, PayoutStatus } from "./payouts";

export const getEnrichedPayout = (payout: IPayout) => ({
  ...payout,
  status: payout.status?.toUpperCase() as PayoutStatus | undefined,
});
